"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const icon_1 = __importDefault(require("../icon"));
const typography_1 = __importDefault(require("../typography"));
const { SuccessCircleIcon, ErrorCircleIcon, InfoIcon, CloseButton } = icon_1.default;
const { StyledSmallText } = typography_1.default;
const SeverityColor = (severity) => {
    const theme = (0, styled_components_1.useTheme)();
    const colorMapping = {
        success: theme.success.main,
        error: theme.error.main,
        warning: theme.primary.main
    };
    return colorMapping[severity] || colorMapping["success"];
};
const SmallText = (0, styled_components_1.default)(StyledSmallText) `
  margin: 0px 16px;
`;
const StyledWrapSnackBar = styled_components_1.default.div `
  width: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 8px;
  left: 8px;
  right: 8px;
  right: auto;
  z-index: 1400;
  ${({ isAnimation }) => isAnimation &&
    (0, styled_components_1.css) `
      animation: displayed-snackbar 0s ease-in 5s forwards;
    `};
  @keyframes displayed-snackbar {
    to {
      width: 0;
      height: 0;
      overflow: hidden;
    }
  }
`;
const StyledSnackBar = styled_components_1.default.div `
  width: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ severity }) => SeverityColor(severity)};
  height: 40px;
  align-items: center;
  border-radius: 5px;
  padding: 15px;
`;
const Icon = (severity, color) => {
    const theme = (0, styled_components_1.useTheme)();
    const iconMapping = {
        success: react_1.default.createElement(SuccessCircleIcon, { color: color || theme.white }),
        error: react_1.default.createElement(ErrorCircleIcon, { color: color || theme.white }),
        warning: react_1.default.createElement(InfoIcon, { color: color || theme.white })
    };
    return iconMapping[severity];
};
const RotaSnackBar = ({ snackOpen, onClose, message, severity = "success", color }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(react_1.default.Fragment, null, snackOpen && (react_1.default.createElement(StyledWrapSnackBar, { isAnimation: !!onClose },
        react_1.default.createElement(StyledSnackBar, { severity: severity },
            Icon(severity, color),
            react_1.default.createElement(SmallText, { color: theme.white }, message),
            react_1.default.createElement("span", { onClick: onClose },
                react_1.default.createElement(CloseButton, { color: theme.white })))))));
};
exports.default = RotaSnackBar;
